export enum MessageResource {
  NONE = 'none',
  EVENT = 'event',
  SERVICE = 'service'
}
